'use client';
import { FC } from 'react';
import {
  Button,
  Flex,
  Text,
  Modal,
  ModalContent,
} from '@eqi-investimentos/react';
import { ModalOverlay, Portal } from '@chakra-ui/react';
import { useT } from '@/libs/i18n/utils/useT';
import { useMaintenance } from '@/hooks/useMaintenance';

export const MaintenanceModalAlert: FC = () => {
  const i18n = useT();

  const { isVisible: isOpen, message, dismssDisclaimer } = useMaintenance();

  const closeModal = () => {
    dismssDisclaimer();
  };

  if (!isOpen) return <></>;

  return (
    <Portal>
      <Modal isOpen={isOpen} onClose={closeModal} size="xs" isCentered>
        <ModalOverlay />
        <ModalContent
          maxW="24.25rem"
          w="full"
          bg="background.primary"
          py="2xl"
          px="l"
          borderRadius="xs"
        >
          <Flex
            direction="column"
            w="full"
            h="full"
            justifyContent="flex-start"
            gap="l"
          >
            <Flex direction="column" gap="xl">
              {message?.title && (
                <Text size="2xl" color="content.seconadry">
                  {message?.title}
                </Text>
              )}
              <Text size="xl" color="content.secondary">
                {message?.description}
              </Text>
            </Flex>
            <Button
              data-testid="button-close-modal-maintenance"
              variant="solid"
              onClick={closeModal}
            >
              {i18n('attributes.understood')}
            </Button>
          </Flex>
        </ModalContent>
      </Modal>
    </Portal>
  );
};
